import { useHandleSynPrevent } from '@op/react-web'
import type { ChangeEvent } from 'react'
import { useLayoutEffect, useMemo, useState } from 'react'
import type { ServerEndpoints } from '../../env'
import { getEndpoints, normalizePrefixUrl, parseUrlPrefix, setEndpoints } from '../../env'
import { Btn, Modal, OPLink } from '../../widgets'

type EpSwitchProps = {
	onClose(): void
}

export const EpSwitch = (p: EpSwitchProps) => {
	if (process.env.APP_ENV !== 'dev') return null

	const [prefix, setPrefix] = useState('local')
	const [isInit, setInit] = useState(false)
	const [endpoints, setLocalEndpoints] = useState<ServerEndpoints>(() => ({
		hfbk: process.env.OURPACT_ENDPOINT_HFBK,
		sfsh: process.env.OURPACT_ENDPOINT_SFSH,
	}))
	const closeModal = () => p.onClose()
	const handleClose = useHandleSynPrevent(closeModal)

	const updatePrefix =
		(newPrefix: string, close = true) =>
		() => {
			const newEndpoints = {
				hfbk: normalizePrefixUrl(newPrefix, 'hfbk'),
				sfsh: normalizePrefixUrl(newPrefix, 'sfsh'),
			}

			setLocalEndpoints(newEndpoints)
			setPrefix(newPrefix)

			setEndpoints(newEndpoints)

			close && closeModal()
		}

	const handlePrefixChange = (ev: ChangeEvent<HTMLInputElement>) => {
		updatePrefix(ev.currentTarget.value, false)()
	}

	useLayoutEffect(() => {
		setPrefix(parseUrlPrefix(getEndpoints()!.sfsh))
		setInit(true)
	}, [])

	const appConfig = useMemo(
		() =>
			[
				`APP_ENV: ${process.env.APP_ENV}`,
				`APP_VERSION: ${process.env.APP_VERSION}`,
				`OURPACT_CLIENT_ID_APPLE: ${process.env.OURPACT_CLIENT_ID_APPLE}`,
				`OURPACT_CLIENT_ID_GOOGLE: ${process.env.OURPACT_CLIENT_ID_GOOGLE}`,
				`OURPACT_ENDPOINT_HFBK: ${endpoints.hfbk}`,
				`OURPACT_ENDPOINT_SFSH: ${endpoints.sfsh}`,
				`OURPACT_GOOGLE_MAPS_API_KEY: ${process.env.OURPACT_GOOGLE_MAPS_API_KEY}`,
				`OURPACT_STRIPE_API_KEY: ${process.env.OURPACT_STRIPE_API_KEY}`,
				`OURPACT_UTIL_MANIFEST_URL: ${process.env.OURPACT_UTIL_MANIFEST_URL}`,
				`SENTRY_DSN: ${process.env.SENTRY_DSN}`,
				`SENTRY_RELEASE: ${process.env.SENTRY_RELEASE}`,
				`SENTRY_URL: ${process.env.SENTRY_URL}`,
			].join('\n'),
		[endpoints],
	)

	if (!isInit) return null

	return (
		<Modal onClose={closeModal} header="Choose an endpoint configuration">
			<h4 className="font-bold text-center">App Config</h4>

			<pre>
				<code>{appConfig}</code>
			</pre>

			<h4 className="font-bold mt-3 mb-5 text-center">Quick Settings</h4>

			<div className="grid grid-cols-3 gap-x-1 mx-auto sm:w-3/4 sm:gap-x-3">
				<Btn size="sm" onClick={updatePrefix('qa')}>
					QA
				</Btn>
				<Btn size="sm" onClick={updatePrefix('local')}>
					Local
				</Btn>
				<Btn size="sm" onClick={updatePrefix('dev-5')}>
					Dev 5
				</Btn>
			</div>

			<form className="flex-center mt-4" onSubmit={handleClose}>
				<div className="field">
					<input
						className="input !w-auto"
						onChange={handlePrefixChange}
						type="text"
						value={prefix}
					/>
				</div>
			</form>

			<div className="flex">
				<OPLink className="mx-auto" to="/demo">
					Go to Demo
				</OPLink>
			</div>
		</Modal>
	)
}
